<template>
  <div id="products-list" class="screen">
    <Title :content="categoryName" v-if="category"/>
    <div id="list-container">
      <div
        class="product"
        v-for="product in productsList"
        :key="product.id"
      >
        <div class="product-image-grid-container">
          <div
            class="product-image"
            :style="{ backgroundImage: 'url('+ product.image +')' }"
          >
            <span v-if="product.image === 'placeholder'" >BRAK ZDJĘCIA</span>
          </div>
        </div>
        <div class="product-name">{{ product.name }}</div>
        <div class="product-description">{{ product.description }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Title from '@/components/Title.vue';

const API = require('../../api.json').api_v1;

export default {
  name: 'ProductsList',
  components: { Title },
  props: {
    category: String,
    productsProps: Array,
  },
  data() {
    return {
      categoryName: '',
      productsList: [
        {
          id: null,
          category_id: null,
          name: '',
          description: '',
          image: 'placeholder',
        },
      ],
    };
  },
  methods: {
    async getFromAPI(query) {
      const result = await axios.get(`${API}/${query}`);
      return result.data.data;
    },
  },
  async created() {
    if (this.productsProps) {
      this.productsList = this.productsProps;
    } else {
      const response = await this.getFromAPI(`products?c=${this.category}`);
      const result = [];

      for (let i = 0; i < response.length; i++) {
        result[i] = {
          id: response[i].id,
          category_id: response[i].category_id,
          name: response[i].name,
          description: response[i].description,
          image: '',
        };

        if (response[i].image === 'placeholder') {
          result[i].image = 'placeholder';
        } else {
          result[i].image = `${API}/products/images/${response[i].image}`;
        }
      }

      const temp = this.category;
      this.categoryName = temp.split('_').join(' ');
      this.productsList = result;
    }
  },
  watch: {
    productsProps() { this.productsList = this.productsProps; },
  },
};
</script>

<style scoped lang="scss">
  #products-list { text-align: center; }

  #list-container {
    display: flex;
    flex-direction: column;
    padding: 25px;
    text-align: left;

    @media (min-width: 1200px) { padding: 25px 250px }
    @media (min-width: 1500px) { padding: 25px 350px }
  }

  .product {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;

    margin: 15px 0;
    padding-bottom: 15px;
    border-bottom: 1px solid #979797;

    @media (min-width: 992px) {
      display: grid;
      grid-template: "image title" 50px "image desc" 1fr / 200px 1fr;
    }
  }

  .product-image-grid-container {
    flex: 100px; height: 100px;

    @media (min-width: 992px) {
      flex: none;
      grid-area: image;
      width: 100%; height: 100%;
      display: flex;
      align-items: center;
    }
  }

  .product-image {
    position: relative;
    flex: 100px; height: 100px;
    background-color: #f2f2f2;

    display: flex;
    justify-content: center;
    align-items: center;

    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;

    span {
      font-size: 0.8em;
      font-weight: bold;

      @media (min-width: 992px) { font-size: 1.3em; }
    }

    @media (min-width: 992px) {
      flex: none;
      width: 200px; height: 200px;
    }
  }

  .product-name {
    position: relative;
    flex: calc(100% - 100px);
    display: flex;

    align-items: center;
    text-align: center;
    font-weight: bold;
    font-size: 1.1em;

    padding: 0 10px;

   @media (min-width: 992px) {
     font-size: 1.3em;
     grid-area: title;
     left: 25px;
   }
  }

  .product-description {
    position: relative;
    flex: 100%;
    margin-top: 10px;
    padding: 0 10px;

    @media (min-width: 992px) {
      grid-area: desc;
      left: 25px;
    }
  }
</style>
